<template>
  <v-dialog
    v-model="localDialog"
    width="80%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>{{ isEntryMode ? "Add User" : "Update User" }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="UserSetup">
          <v-row>
            <v-col lg="4" md="4" cols="12">
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="first_name.value.value"
                :error-messages="first_name.errorMessage.value"
                clearable
              >
                <template #label>
                  First Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="username.value.value"
                :error-messages="username.errorMessage.value"
                clearable
              >
                <template #label>
                  User Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field
                density="compact"
                :type="visible ? 'text' : 'password'"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="password.value.value"
                :error-messages="password.errorMessage.value"
                @click:append-inner="visible = !visible"
                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                :disabled="isEntryMode ? false : true"
                clearable
              >
                <template #label>
                  Password <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="mobile.value.value"
                :error-messages="mobile.errorMessage.value"
                clearable
              >
                <template #label>
                  Mobile <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <!-- <v-text-field
                label="Tag"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="tag.value.value"
                :error-messages="tag.errorMessage.value"
                clearable
              ></v-text-field> -->
            </v-col>

            <v-col lg="4" md="4" cols="12">
              <v-text-field
                label="Last Name"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="last_name.value.value"
                :error-messages="last_name.errorMessage.value"
                clearable
              ></v-text-field>

              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="email.value.value"
                :error-messages="email.errorMessage.value"
                clearable
              >
                <template #label>
                  Email <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field
                :type="visible ? 'text' : 'password'"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="retypepassword.value.value"
                :error-messages="retypepassword.errorMessage.value"
                @click:append-inner="visible = !visible"
                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                :disabled="isEntryMode ? false : true"
                clearable
              >
                <template #label>
                  Re-Type Password <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field
                label="Remarks"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="remarks.value.value"
                :error-messages="remarks.errorMessage.value"
                clearable
              ></v-text-field>
            </v-col>

            <v-col lg="4" md="4" cols="12">
              <v-autocomplete
                  label="Select Company"
                  density="compact"
                  single-line
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="company_id.value.value"
                  :error-messages="company_id.errorMessage.value"
                  clearable
                  :items="getCompanyList.filter(item=> item.status == 1)"
                  :item-title="item => `${item.name} - ${item.code}`"                                                  
                  item-value="id"
                  autocomplete="off"
              >
                <template #label>
                  Select Company <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <v-autocomplete
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="branch_id.value.value"
                :items="getBranchList.filter(item => item.company_id == this.company_id.value.value)"
                :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                item-value="id"
                :error-messages="branch_id.errorMessage.value"
                autocomplete="off"
                clearable
              >
                <template #label>
                  Select Branch (Primary) <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <v-autocomplete
                label="Select Role (Primary)"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="role_id.value.value"
                :items="getRoleList.filter(item => item.branch_id == this.branch_id.value.value)"
                :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                item-value="id"
                :error-messages="role_id.errorMessage.value"
                autocomplete="off"
                clearable
              ></v-autocomplete>

              <v-file-input
                v-model="selectedImage"
                label="Select an Image"
                accept="image/*"
                density="compact"
                single-line
                variant="outlined"
                bg-color="grey-lighten-4"
                show-size
                @input="previewImage"
                @click:clear="clearImage"
                class="ellipsis-filename"
                persistent-hint
                hint="Image must be exactly 120px × 120px"
                title="image"
              >
            </v-file-input>

              <div style="float: right; text-align: center; margin-top: 10px;">
                <v-img :src="preview" cover class="preview-image"></v-img>
              </div>
              

              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                value="1"
              ></v-checkbox>
              
              <input v-model="user_id.value.value" type="hidden" />
              <input v-model="employee_id.value.value" type="hidden" />
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import { fileServerUrl } from "@/store/api";

export default {
  name: 'UserSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        employee_id: '',
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        mobile: '',
        tag: '',
        remarks: '',
        status: '1',
        branch_id: null,
        role_id: null,
        user_id: null,
        branch: {
          company_id: null,
        },
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: '',
      preview: '/src/assets/no_preview.jpeg',
      loading: false,
      selectedFavicon: null,
      isEntryMode: true,
    }
  },
  computed: {
    getRoleList() {
      return this.$store.getters.getRoleList;
    },
    getCompanyList() {
        return this.$store.getters.getCompanyList;
    },
    getBranchList() {
      return this.$store.getters.getBranchList;
    },
    
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.first_name.setValue(newData.first_name || '', false);
        this.last_name.setValue(newData.last_name || '', false);
        this.username.setValue(newData.username || '', false);
        this.email.setValue(newData.email || '', false);
        this.mobile.setValue(newData.mobile || '', false);
        this.tag.setValue(newData.tag || '', false);
        this.remarks.setValue(newData.remarks || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.company_id.setValue(newData.branch.company_id  || null , false);
        this.user_id.setValue(newData.id || '', false);
        this.employee_id.setValue(newData.employee_id || '', false);
        this.preview = newData.logo ? fileServerUrl + newData.logo : '/src/assets/no_preview.png';
        this.$nextTick(() => {
          this.branch_id.setValue(newData.branch_id || null, false);
        });
        this.$nextTick(() => {
          setTimeout(() => {
            this.role_id.setValue(newData.role_id || null, false);
              this.role_id.validate();
          }, 100);
        });

      },
    }
    
  },
  created() {
    if(this.$store.getters.getRoleList.length == 0){
          this.loading = true;
            this.$store.dispatch('getRoleList').then((response) => {
              this.loading = false;
          })
    };
    if(this.$store.getters.getBranchList.length == 0){
          this.loading = true;
            this.$store.dispatch('getBranchList').then((response) => {
              this.loading = false;
          })
    };
  },
  methods: {
    previewImage: function(event) {
        this.selectedImage = event.target.files[0];
        const input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.preview = e.target.result;
            }
            this.image = input.files[0];
            reader.readAsDataURL(input.files[0]);
        }
        else {
            this.preview = '/src/assets/no_preview.jpeg';
        }
    },
    clearImage() {
        this.preview = '/src/assets/no_preview.jpeg';
    },
    clearFavicon() {
        this.selectedFavicon = null;
    },
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          first_name: yup.string().min(4).max(50).required().trim().label('first_name'),
          last_name: yup.string().max(50).nullable().trim().label('last_name'),
          username: yup.string().min(6).max(50).nullable().trim().label('username'),
          email: yup.string().email().required().trim().label('Email'),
          mobile: yup.string().min(7).max(15).required("Mobile Number is Requird").label('Mobile'),
          tag: yup.string().nullable().trim().max(60).label('tag'),
          remarks: yup.string().max(150).nullable().trim().label('remarks'),
          password: yup.string()
                        .when('user_id', {
                        is: (val) => !val, // jodi user_id na thake
                        then: (schema) =>
                            schema
                            .required('Password is required')
                            .matches(
                                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,12}$/,
                                'Password must contain at least one letter, one number, and one special character and be 8 to 12 characters long'
                            )
                            .test('no-spaces', 'Spaces are not allowed', (value) => !/\s/.test(value)),
                        otherwise: (schema) => schema.notRequired().nullable(),
                        }),
                              
          retypepassword: yup.string()
                    .when('user_id', {
                    is: (val) => !val,
                    then: (schema) =>
                        schema
                        .required('Retype Password is required')
                        .oneOf([yup.ref('password')], 'Passwords must match'),
                    otherwise: (schema) => schema.notRequired().nullable(),
                    }),
          company_id: yup.number().positive().integer().required().label('Company'),
          branch_id: yup.number().positive().integer().required().label('Branch'),
          role_id: yup.number().when('branch_id', {
                    is: (val) => val,
                    then: (schema) => schema.positive().integer().required(' Role is required'),
                    otherwise: (schema) => schema.notRequired().nullable(),
          }),
      }),

    });

    const first_name = useField('first_name');
    const last_name = useField('last_name');
    const employee_id = useField('employee_id');
    const username = useField('username');
    const mobile = useField('mobile');
    const email = useField('email');
    const tag = useField('tag');
    const password = useField('password');
    const retypepassword = useField('retypepassword');
    const remarks = useField('remarks');
    const status = useField('status');
    const company_id = useField('company_id');
    const branch_id = useField('branch_id');
    const role_id = useField('role_id');
    const user_id = useField('user_id');
    const visible = ref(false);
    const errorMessages  = ref('');
    const selectedImage  = ref(null);
    const loading  = ref('');
    const store = useStore();

    watch(() => company_id.value.value, () => {
      branch_id.value.value = null;
    });

    watch(() => branch_id.value.value, () => {
      role_id.value.value = null;
    });

    const submit = handleSubmit((values) => {

          // Create a FormData object
          const formData = new FormData();

          // Append all form values to FormData
          Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
          });

          // Append the selected image to FormData
          if (selectedImage.value) {
              formData.append('image', selectedImage.value); // 'logo' is the key for the file
          }

        store.dispatch("saveUpdateUserSetup", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getUsersList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);   
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      first_name,
      last_name,
      username,
      mobile,
      employee_id,
      email,
      tag,
      remarks,
      status,
      errorMessages,
      visible,
      company_id,
      branch_id,
      role_id,
      user_id,
      password,
      retypepassword,
      selectedImage,
      resetForm,
      loading
    }
  },
  mounted() {
    this.retypepassword.value.value = '';
    this.company_id.value.value = null;
    this.branch_id.value.value = null;
    this.role_id.value.value = null;
  }
}
</script>

